<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="$t('perfil')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('email')" prop="mail">
          <el-col :xs="24" :sm="18" :md="18" :lg="8" :xl="8">
            <el-input type="email" ref="mail" v-model="ruleForm.mail"></el-input>
          </el-col>
        </el-form-item>

        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('login')" prop="username">
              <el-input ref="username" disabled v-model="ruleForm.username"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('senha')" prop="password">
              <el-input type="password" ref="password" v-model="ruleForm.password" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="ruleForm.type === '1' || ruleForm.type === '3'">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('atendimento-chat')" prop="department">
              <DepartmentChat v-model="ruleForm.department" :current="ruleForm.department" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">Desejo Receber Notificações</el-divider>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item prop="viamail">
              <el-checkbox ref="viamail" v-model="ruleForm.viamail">{{ $t('via-e-mail') }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item label=" " prop="whatsapp">
              <el-checkbox ref="whatsapp" v-model="ruleForm.whatsapp">{{ $t('whatsapp') }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('celular')" prop="cellphone">
              <el-input ref="cellphone" v-model="ruleForm.cellphone" :disabled="!ruleForm.whatsapp"
                v-mask="['(##) #####-####', '(##) #####-####']"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider v-if="ruleForm.whatsapp" content-position="left">Notificações que gostaria de receber</el-divider>
        <el-row :gutter="5" v-if="ruleForm.whatsapp">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item>
              <!--el-checkbox ref="prepost" v-model="ruleForm.notification.prepost">{{ $t('prepostagem-criada')
              }}</el-checkbox>
              <el-checkbox ref="collected" v-model="ruleForm.notification.collected">{{ $t('prepostagem-coletada')
              }}</el-checkbox>
              <el-checkbox ref="plp" v-model="ruleForm.notification.plp">{{ $t('plp-gerada')
              }}</el-checkbox>
              <el-checkbox ref="post" v-model="ruleForm.notification.post">{{ $t('postagem-correios') }}</el-checkbox>
              <el-checkbox ref="traffic" v-model="ruleForm.notification.traffic">{{ $t('postagem-em-transito')
              }}</el-checkbox>
              <el-checkbox ref="out" v-model="ruleForm.notification.out">{{ $t('postagem-saiu-entrega') }}</el-checkbox>
              <el-checkbox ref="delivered" v-model="ruleForm.notification.delivered">{{ $t('postagem-entregue')
              }}</el-checkbox>
              <el-checkbox ref="delivered" v-model="ruleForm.notification.requestinfo">{{ $t('requisicao-informacao')
              }}</el-checkbox -->
              <el-checkbox ref="message" v-model="ruleForm.notification.message">{{ $t('mensagem')
              }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{
            $t("atualizar")
          }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import DepartmentChat from '@/xpost/views/register/department/DepartmentChat'

export default {
  name: "Profile",
  components: {
    DepartmentChat
  },
  data() {
    return {
      id: "",
      ruleForm: {
        name: "",
        mail: "",
        username: "",
        password: "",
        type: "1",
        department: '',
        role: "1",
        whatsapp: false,
        viamail: false,
        cellphone: '',
        notification: {
          prepost: true,
          plp: true,
          collected: true,
          post: true,
          traffic: true,
          out: true,
          delivered: true,
          requestinfo: true,
          message: true,
        }
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: i18n.tc("email-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "home" });

    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          UserService.profile(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("perfil-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.ruleForm.type = response.type;
        vm.ruleForm = response;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
        }
        //        vm.$refs.name.$el.children[0].focus();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
